"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FRAMEWORK_CONCEPT_OR_ITERATION_TAG_CATEGORY_NAME = exports.FRAMEWORK_FORMAT_TAG_CATEGORY_NAME = void 0;
exports.isFrameworkFormatTagCategory = isFrameworkFormatTagCategory;
exports.isFrameworkConceptOrIterationTagCategory = isFrameworkConceptOrIterationTagCategory;
exports.isProtectedFrameworkConceptOrIterationTag = isProtectedFrameworkConceptOrIterationTag;
function normalizeBatchTagLabel(value) {
    return value.trim().toLowerCase();
}
/**
 * Framework batch tag category: display name is matched case-insensitively.
 *
 * **Rename caveat:** If an org renames this category, the Format-only behaviors keyed off
 * this name (subtag nesting in the settings UI) stop applying until the constant is updated,
 * or you add a dedicated DB flag on the category.
 *
 * **Nesting is optional.** Format tags may be created top-level or under a parent. An earlier
 * rule forced every Format tag after the first to nest under an existing parent; it was
 * removed deliberately, because it left no way to add a second top-level format from the UI.
 * Format is still the only category whose subtags the settings UI renders, so nesting is
 * restricted to it — see TagDialog's parent selector.
 */
exports.FRAMEWORK_FORMAT_TAG_CATEGORY_NAME = "format";
function isFrameworkFormatTagCategory(categoryName) {
    return (normalizeBatchTagLabel(categoryName) === exports.FRAMEWORK_FORMAT_TAG_CATEGORY_NAME);
}
exports.FRAMEWORK_CONCEPT_OR_ITERATION_TAG_CATEGORY_NAME = "new concept or iteration";
const FRAMEWORK_PROTECTED_CONCEPT_OR_ITERATION_TAG_NAMES = new Set([
    "new concept",
    "iteration",
]);
function isFrameworkConceptOrIterationTagCategory(categoryName) {
    return (normalizeBatchTagLabel(categoryName) ===
        exports.FRAMEWORK_CONCEPT_OR_ITERATION_TAG_CATEGORY_NAME);
}
function isProtectedFrameworkConceptOrIterationTag(categoryName, tagName, parentTagId) {
    return (!parentTagId &&
        isFrameworkConceptOrIterationTagCategory(categoryName) &&
        FRAMEWORK_PROTECTED_CONCEPT_OR_ITERATION_TAG_NAMES.has(normalizeBatchTagLabel(tagName)));
}
